const resultPageHandle = 'transcriptomics-workflow-generator-results'
const resultCategory = 'Transcriptomics'

//input workflow object (manages input)
var inputWFObj = {
	"Sample": {
		"stepName": "Sample",
		"htmlText": "Sample Type",
		"sessionName": "sampleTypeTranscriptomics", //make sure it's unique between all workflow generators
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false, //use remove conflicts
		"isProduct": true
	},
	"Application": {
		"stepName": "Application",
		"htmlText": "Application",
		"sessionName": "applicationTranscriptomics",
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false,
		"isProduct": true
	},
	"TRIzol": {
		"stepName": "TRIzol",
		"htmlText": "TRIzol",
		"sessionName": "trizolTranscriptomics",
		"value" : "", //will change depending on what's selected
		"stepType": "dependent", //dependent: show disabled
		"isAnchor": false,
		"isProduct": true
	}
}

const resultCategories = ['Sample Collection','RNA Extraction','RNA Library Kit']

const mappedProducts = {
}

const autoInput = {
	"Sample":{
		"Reset" : ['Reset'],
        // "Sample in TRIzol": ["Sample in TRIzol"],
		"Mammalian Cells": ["Mammalian Cells"],
		"Animal Tissue": ["Animal Tissue"],
		"FFPE Tissue": ["FFPE Tissue"],
		"Blood": ["Blood"],
		"Buffy Coat": ["Buffy Coat"],
		"Serum & Plasma": ["Serum & Plasma"],
		"Buccal, Nasal, Throat": ["Buccal, Nasal, Throat"],
		"Swab": ["Swab"],
		"Saliva": ["Saliva"],
		"Urine": ["Urine"],
		"Fungus": ["Fungus"],
		"Insect": ["Insect"],
		"Plant": ["Plant"]
    },
    "Application":{
		// "Next-Generation Sequencing": ["Alternative Splicing", "Non-Coding Transcript Detection", "Oligo-dT primer-based", "Protein Coding Analysis", "Whole Transcriptome Analysis", "rRNA depletion-based"]
		"Reset" : ['Reset'],
		"Whole Transcriptome Analysis": ["Whole Transcriptome Analysis"],
		"Protein Coding Analysis": ["Protein Coding Analysis"], 
		"rRNA depletion-based": ["rRNA depletion-based"],
		"Oligo-dT primer-based": ["Oligo-dT primer-based"], 
		"Alternative Splicing": ["Alternative Splicing"], 
		"Non-Coding Transcript Detection": ["Non-Coding Transcript Detection"]
    }
	,
    "TRIzol":{
		"Reset" : ['Reset'],
		"No TRIzol": ["No TRIzol"],
		"With TRIzol": ["With TRIzol"]
    }
}

const bulkProducts = 	["dna-rna-shield","dna-rna-shield-blood-collection-tube","dna-rna-shield-collection-tube-w-swab",
						"dna-rna-shield-collection-tube-w-swab-dx","dna-rna-shield-fecal-collection-kit","dna-rna-shield-fecal-collection-tube",
						"dna-rna-shield-fecal-collection-tube-dx","dna-rna-shield-lysis-and-collection-tubes","dna-rna-shield-safecollect-saliva-collection-kit",
						"dna-rna-shield-safecollect-swab-collection-kit","dna-rna-shield-saliva-collection-kit","dna-rna-shield-saliva-sputum-collection-kit-dx",
						"dnase-i-set","proteinase-k-w-storage-buffer-set","rnase-a","sterile-collection-swab","urine-conditioning-buffer",
						"zr-96-bashingbead-lysis-rack-barcoded","zymolyase"]

const resultData = { 
	"custom":{
		'Illumina-DNA-Prep-Kit':{
			"title": "Illumina DNA Prep Kit",
			"description": `Illumina DNA Prep, previously known as Nextera DNA Flex, offers a fast, robust, and flexible workflow for preparing normalized, sequencing-ready libraries from a wide range of DNA input types and amounts facilitating an array of applications, from human whole-genome sequencing to sequencing amplicons, plasmids, and microbial species.`,
			"image-url": "https://files.zymoresearch.com/images/illumina-nextera-dna-flex-library-prep-kit.webp",
			"location-parent": "RNA Library Kit",
			"location":"RNA Library Kit Header",
			"location-relative":"afterend",
			"cta": "View Product",
			"url": "https://emea.illumina.com/products/by-type/sequencing-kits/library-prep-kits/illumina-dna-prep.html",
			"cta-function": "window.open('https://emea.illumina.com/products/by-type/sequencing-kits/library-prep-kits/illumina-dna-prep.html', '_blank').focus();"
		}, 
		'Illumina-DNA-Prep-Kit-alt':{
			"title": "Illumina DNA Prep Kit",
			"description": `The Microlab Prep is a benchtop liquid handling platform ideal for sample prep, PCR prep, library prep, or small to mid-scale nucleic acid extraction workflows. <a href="/pages/microbiome-analysis-services#promotions-section" target="_blank">Learn More</a>`,
			"image-url": "https://files.zymoresearch.com/images/workflow_instruments/ml_prep.webp",
			"location-parent": "RNA Library Kit",
			"location":"RNA Library Kit",
			"location-relative":"beforeend",
			"cta": "View Product",
			"url": "/pages/microbiome-analysis-services#promotions-section",
			"cta-function": "window.open('/pages/yeast', '_blank').focus();"
		}, 
	}
}

const customSize = {
	"D6421-PS1": "96 rxns, Primer Set 1",
	"D6421-PS2": "96 rxns, Primer Set 2",
	"D6421-PS3": "96 rxns, Primer Set 3",
	"D6421-PS4": "96 rxns, Primer Set 4",
	"D6421-PS5": "96 rxns, Primer Set 5",
	"D6421-PS6": "96 rxns, Primer Set 6",
	"D6421-PS7": "96 rxns, Primer Set 7",
	"D6421-PS8": "96 rxns, Primer Set 8",
	"D6430-PS1": "96 rxns, Primer Set 1",
	"D6430-PS2": "96 rxns, Primer Set 2",
	"D6430-PS3": "96 rxns, Primer Set 3",
	"D6430-PS4": "96 rxns, Primer Set 4",
	"R2061": "50 preps, (w/ 50 ml TRI Reagent)",
	"R2063": "100 preps, (w/ 100 ml TRI Reagent)",
	"R2051": "50 preps, (w/ 50 ml TRI Reagent)",
	"R2053": "200 preps, (w/ 200 ml TRI Reagent)",
	"R2071": "50 preps, (w/ 50 ml TRI Reagent)",
	"R2073": "200 preps, (w/ 200 ml TRI Reagent)",
	"R2055": "2 x 96 preps, (w/ 200 ml x 1 TRI Reagent)",
	"R2057": "4 x 96 preps, (w/ 200 ml x 2 TRI Reagent)",
	"R2103": "4 x 96 preps, (w/ 200 ml x 2 TRI Reagent)",
	"R2101": "1 x 96 preps, (w/ 50 ml x 2 TRI Reagent)",
	"R2100": "1 x 96 preps",
	"R1160-10": "10 pack , 1ml",
	"R1161-10": "10 pack , 2ml",
	"R1160-50": "50 pack , 1ml",
	"R1161-50": "50 pack , 2ml",
}

function wufooFormDisplay(){
	$('#global-modal-center-title').text('')
	let modalHTML = ` <div id="wufoo-p11hnppz1hz4adc"> Fill out my <a href="https://zymoresearch.wufoo.com/forms/p11hnppz1hz4adc">online form</a>. </div>`;
	$('#global-modal-center-content').html(modalHTML);
	var p11hnppz1hz4adc; (function(d, t) { var s = d.createElement(t), options = { 'userName':'zymoresearch', 'formHash':'p11hnppz1hz4adc', 'autoResize':true, 'height':'645', 'async':true, 'host':'wufoo.com', 'header':'show', 'ssl':true }; s.src = ('https:' == d.location.protocol ?'https://':'http://') + 'secure.wufoo.com/scripts/embed/form.js'; s.onload = s.onreadystatechange = function() { var rs = this.readyState; if (rs) if (rs != 'complete') if (rs != 'loaded') return; try { p11hnppz1hz4adc = new WufooForm(); p11hnppz1hz4adc.initialize(options); p11hnppz1hz4adc.display(); } catch (e) { } }; var scr = d.getElementsByTagName(t)[0], par = scr.parentNode; par.insertBefore(s, scr); })(document, 'script'); 
	$("#global-modal-center-btn").click();
}

$(document).ready(function() {
	let trizolCheck = decodeURI(window.location.href.split('?')[1]).split('+').indexOf('With TRIzol') >= 0
	if(trizolCheck){
		document.getElementById('auto-dropdown-container').innerHTML += `
		<div class="workflow-checkbox">
			<input type="checkbox" id="TRIzolCheckbox" name="TRIzolCheckbox" checked>
			<label for="TRIzolCheckbox">Sample Stored in TRIzol</label><br>
		</div>
		`
	}
	else{
		document.getElementById('auto-dropdown-container').innerHTML += `
		<div class="workflow-checkbox">
			<input type="checkbox" id="TRIzolCheckbox" name="TRIzolCheckbox">
			<label for="TRIzolCheckbox">Sample Stored in TRIzol</label><br>
		</div>
		`
	}

	document.getElementById('TRIzol-dropdown').classList.add('d-none')

	document.getElementById('TRIzolCheckbox').addEventListener('change', function() {
		if (this.checked) {
			select_item('With TRIzol','TRIzol')
			console.log('select with trizol')
		}
		else{
			select_item('No TRIzol','TRIzol')
			console.log('select no trizol')
		}
	});

	document.getElementById('reset-button').addEventListener('click', function() {
		select_item('No TRIzol','TRIzol')
		document.getElementById("TRIzolCheckbox").checked = false;
		
		document.getElementById('TRIzolCheckbox').addEventListener('change', function() {
			if (this.checked) {
				select_item('With TRIzol','TRIzol')
				console.log('select with trizol')
			}
			else{
				select_item('No TRIzol','TRIzol')
				console.log('select no trizol')
			}
		});
	});

	if(inputWFObj.TRIzol.value == ''){
		select_item('No TRIzol','TRIzol')
	}

	document.getElementById('auto-dropdown-container').style.alignItems = 'flex-start';
	document.getElementById('auto-dropdown-container').style.position = 'relative';
	// document.getElementById('Sample-dropdown').style.marginBottom = '24px';
	
	document.getElementById('workflow-share').innerHTML +=	`
	<button onclick="wufooFormDisplay()" type="button" class="wf-header-button"><span class="header-icon"><i class="fa fa-envelope" aria-hidden="true"></i> Contact Us </span></button>
	`;
});



const autoOutput = {
	"Mammalian Cells?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-microprep-kit,quick-rna-miniprep-kit,quick-rna-magbead,quick-rna-96-kit",
		"RNA Extraction Numbers":"R1050,R1051,R1054,R1055,R2132,R2133,R1052,R1053",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-microprep-kit,quick-rna-miniprep-kit,quick-rna-magbead,quick-rna-96-kit",
		"RNA Extraction Numbers":"R1050,R1051,R1054,R1055,R2132,R2133,R1052,R1053",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-microprep-kit,quick-rna-miniprep-kit,quick-rna-magbead,quick-rna-96-kit",
		"RNA Extraction Numbers":"R1050,R1051,R1054,R1055,R2132,R2133,R1052,R1053",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Protein Coding Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-microprep-kit,quick-rna-miniprep-kit,quick-rna-magbead,quick-rna-96-kit",
		"RNA Extraction Numbers":"R1050,R1051,R1054,R1055,R2132,R2133,R1052,R1053",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Mammalian Cells?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-microprep-kit,quick-rna-miniprep-kit,quick-rna-magbead,quick-rna-96-kit",
		"RNA Extraction Numbers":"R1050,R1051,R1054,R1055,R2132,R2133,R1052,R1053",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Oligo-dT primer-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-microprep-kit,quick-rna-miniprep-kit,quick-rna-magbead,quick-rna-96-kit",
		"RNA Extraction Numbers":"R1050,R1051,R1054,R1055,R2132,R2133,R1052,R1053",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Animal Tissue?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Animal Tissue?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"AnimalTissue?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Animal Tissue?Protein Coding Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Animal Tissue?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Animal Tissue?Oligo-dT primer-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"FFPE Tissue?Whole Transcriptome Analysis?No TRIzol": {
		"RNA Extraction Handle":"quick-rna-ffpe-miniprep,pinpoint-slide-rna-isolation-system",
		"RNA Extraction Numbers":"R1008,R1007",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"FFPE Tissue?Alternative Splicing?No TRIzol": {
		"RNA Extraction Handle":"quick-rna-ffpe-miniprep,pinpoint-slide-rna-isolation-system",
		"RNA Extraction Numbers":"R1008,R1007",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"FFPE Tissue?Non-Coding Transcript Detection?No TRIzol": {
		"RNA Extraction Handle":"quick-rna-ffpe-miniprep,pinpoint-slide-rna-isolation-system",
		"RNA Extraction Numbers":"R1008,R1007",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "FFPE Tissue?Protein Coding Analysis?No TRIzol": { //hi
	// 	"RNA Extraction Handle":"quick-rna-ffpe-miniprep,pinpoint-slide-rna-isolation-system",
	// 	"RNA Extraction Numbers":"R1008,R1007",
		
	// },
	"FFPE Tissue?rRNA depletion-based?No TRIzol": {
		"RNA Extraction Handle":"quick-rna-ffpe-miniprep,pinpoint-slide-rna-isolation-system",
		"RNA Extraction Numbers":"R1008,R1007",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "FFPE Tissue?Oligo-dT primer-based?No TRIzol": { //hi
	// 	"RNA Extraction Handle":"quick-rna-ffpe-miniprep,pinpoint-slide-rna-isolation-system",
	// 	"RNA Extraction Numbers":"R1008,R1007",
		
	// },
	"Blood?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-blood-collection-tube,dna-rna-shield",
		"Sample Collection Numbers":"R1150,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-dna-rna-blood-tube-kit,quick-rna-whole-blood",
		"RNA Extraction Numbers":"R1151,R1201",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-blood-collection-tube,dna-rna-shield",
		"Sample Collection Numbers":"R1150,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-dna-rna-blood-tube-kit,quick-rna-whole-blood",
		"RNA Extraction Numbers":"R1151,R1201",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-blood-collection-tube,dna-rna-shield",
		"Sample Collection Numbers":"R1150,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-dna-rna-blood-tube-kit,quick-rna-whole-blood",
		"RNA Extraction Numbers":"R1151,R1201",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Protein Coding Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-blood-collection-tube,dna-rna-shield",
		"Sample Collection Numbers":"R1150,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-dna-rna-blood-tube-kit,quick-rna-whole-blood",
		"RNA Extraction Numbers":"R1151,R1201",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Blood?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-blood-collection-tube,dna-rna-shield",
		"Sample Collection Numbers":"R1150,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-dna-rna-blood-tube-kit,quick-rna-whole-blood",
		"RNA Extraction Numbers":"R1151,R1201",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Oligo-dT primer-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-blood-collection-tube,dna-rna-shield",
		"Sample Collection Numbers":"R1150,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-dna-rna-blood-tube-kit,quick-rna-whole-blood",
		"RNA Extraction Numbers":"R1151,R1201",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Buffy Coat?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Protein Coding Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Buffy Coat?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Oligo-dT primer-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Serum & Plasma?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-cfrna-serum-plasma-kit",
		"RNA Extraction Numbers":"R1059",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Extraction 3 Handle":"oligo-clean-concentrator",
		"RNA Extraction 3 Numbers":"D4060,D4061",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Serum & Plasma?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-cfrna-serum-plasma-kit",
		"RNA Extraction Numbers":"R1059",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Extraction 3 Handle":"oligo-clean-concentrator",
		"RNA Extraction 3 Numbers":"D4060,D4061",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Serum & Plasma?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-cfrna-serum-plasma-kit",
		"RNA Extraction Numbers":"R1059",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Extraction 3 Handle":"oligo-clean-concentrator",
		"RNA Extraction 3 Numbers":"D4060,D4061",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Serum & Plasma?Protein Coding Analysis?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield",
	// 	"Sample Collection Numbers":"R1100-50,R1100-250",
	// 	"RNA Extraction Handle":"quick-cfrna-serum-plasma-kit",
	// 	"RNA Extraction Numbers":"R1059",
	// 	"RNA Extraction 2 Handle":"dnase-i-set",
	// 	"RNA Extraction 2 Numbers":"E1010",
	// 	"RNA Extraction 3 Handle":"oligo-clean-concentrator",
	// 	"RNA Extraction 3 Numbers":"D4060,D4061",
		
	// },
	"Serum & Plasma?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield",
		"Sample Collection Numbers":"R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-cfrna-serum-plasma-kit",
		"RNA Extraction Numbers":"R1059",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Extraction 3 Handle":"oligo-clean-concentrator",
		"RNA Extraction 3 Numbers":"D4060,D4061",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Serum & Plasma?Oligo-dT primer-based?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield",
	// 	"Sample Collection Numbers":"R1100-50,R1100-250",
	// 	"RNA Extraction Handle":"quick-cfrna-serum-plasma-kit",
	// 	"RNA Extraction Numbers":"R1059",
	// 	"RNA Extraction 2 Handle":"dnase-i-set",
	// 	"RNA Extraction 2 Numbers":"E1010",
	// 	"RNA Extraction 3 Handle":"oligo-clean-concentrator",
	// 	"RNA Extraction 3 Numbers":"D4060,D4061",
		
	// },
	"Buccal, Nasal, Throat?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buccal, Nasal, Throat?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buccal, Nasal, Throat?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Buccal, Nasal, Throat?Protein Coding Analysis?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
	// 	"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
	// 	"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
	// 	"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		
	// },
	"Buccal, Nasal, Throat?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Buccal, Nasal, Throat?Oligo-dT primer-based?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
	// 	"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
	// 	"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
	// 	"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		
	// },
	"Swab?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Swab?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Swab?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Swab?Protein Coding Analysis?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
	// 	"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
	// 	"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
	// 	"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		
	// },
	"Swab?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
		"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Swab?Oligo-dT primer-based?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield-collection-tube-w-swab,dna-rna-shield-safecollect-swab-collection-kit",
	// 	"Sample Collection Numbers":"R1106,R1107,R1108,R1109,R1107-E,R1109-E,R1160,R1161,R1160-E,R1161-E,R1160-10,R1161-10,R1160-50,R1161-50",
	// 	"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
	// 	"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		
	// },
	"Saliva?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Sample Collection Numbers":"R1211,R1211-10,R1211-50,R1211-E,R1211-F",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Saliva?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Sample Collection Numbers":"R1211,R1211-10,R1211-50,R1211-E,R1211-F",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Saliva?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Sample Collection Numbers":"R1211,R1211-10,R1211-50,R1211-E,R1211-F",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Saliva?Protein Coding Analysis?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
	// 	"Sample Collection Numbers":"R1211,R1211-10,R1211-50,R1211-E,R1211-F",
	// 	"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
	// 	"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		
	// },
	"Saliva?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
		"Sample Collection Numbers":"R1211,R1211-10,R1211-50,R1211-E,R1211-F",
		"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
		"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Saliva?Oligo-dT primer-based?No TRIzol": {
	// 	"Sample Collection Handle":"dna-rna-shield-safecollect-saliva-collection-kit",
	// 	"Sample Collection Numbers":"R1211,R1211-10,R1211-50,R1211-E,R1211-F",
	// 	"RNA Extraction Handle":"quick-rna-miniprep-plus-kit,quick-rna-magbead",
	// 	"RNA Extraction Numbers":"R1057,R1058,R2132,R2133",
		
	// },
	"Urine?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"urine-collection-kit,urine-conditioning-buffer",
		"Sample Collection Numbers":"D3062,D3061-1-8,D3061-1-140",
		"RNA Extraction Handle":"zr-urine-rna-isolation-kit",
		"RNA Extraction Numbers":"R1038,R1039",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Urine?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"urine-collection-kit,urine-conditioning-buffer",
		"Sample Collection Numbers":"D3062,D3061-1-8,D3061-1-140",
		"RNA Extraction Handle":"zr-urine-rna-isolation-kit",
		"RNA Extraction Numbers":"R1038,R1039",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Urine?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"urine-collection-kit,urine-conditioning-buffer",
		"Sample Collection Numbers":"D3062,D3061-1-8,D3061-1-140",
		"RNA Extraction Handle":"zr-urine-rna-isolation-kit",
		"RNA Extraction Numbers":"R1038,R1039",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Urine?Protein Coding Analysis?No TRIzol": {
	// 	"Sample Collection Handle":"urine-collection-kit,urine-conditioning-buffer",
	// 	"Sample Collection Numbers":"D3062,D3061-1-8,D3061-1-140",
	// 	"RNA Extraction Handle":"zr-urine-rna-isolation-kit",
	// 	"RNA Extraction Numbers":"R1038,R1039",
	// 	"RNA Extraction 2 Handle":"dnase-i-set",
	// 	"RNA Extraction 2 Numbers":"E1010",
		
	// },
	"Urine?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"urine-collection-kit,urine-conditioning-buffer",
		"Sample Collection Numbers":"D3062,D3061-1-8,D3061-1-140",
		"RNA Extraction Handle":"zr-urine-rna-isolation-kit",
		"RNA Extraction Numbers":"R1038,R1039",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Urine?Oligo-dT primer-based?No TRIzol": {
	// 	"Sample Collection Handle":"urine-collection-kit,urine-conditioning-buffer",
	// 	"Sample Collection Numbers":"D3062,D3061-1-8,D3061-1-140",
	// 	"RNA Extraction Handle":"zr-urine-rna-isolation-kit",
	// 	"RNA Extraction Numbers":"R1038,R1039",
	// 	"RNA Extraction 2 Handle":"dnase-i-set",
	// 	"RNA Extraction 2 Numbers":"E1010",
		
	// },
	"Fungus?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1103,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-fungal-bacterial-microprep-kit,quick-rna-fungal-bacterial-miniprep-kit",
		"RNA Extraction Numbers":"R2010,R2014",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1103,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-fungal-bacterial-microprep-kit,quick-rna-fungal-bacterial-miniprep-kit",
		"RNA Extraction Numbers":"R2010,R2014",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1103,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-fungal-bacterial-microprep-kit,quick-rna-fungal-bacterial-miniprep-kit",
		"RNA Extraction Numbers":"R2010,R2014",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Protein Coding Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1103,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-fungal-bacterial-microprep-kit,quick-rna-fungal-bacterial-miniprep-kit",
		"RNA Extraction Numbers":"R2010,R2014",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Fungus?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1103,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-fungal-bacterial-microprep-kit,quick-rna-fungal-bacterial-miniprep-kit",
		"RNA Extraction Numbers":"R2010,R2014",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Oligo-dT primer-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1103,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-fungal-bacterial-microprep-kit,quick-rna-fungal-bacterial-miniprep-kit",
		"RNA Extraction Numbers":"R2010,R2014",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Insect?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-tissue-insect-kit",
		"RNA Extraction Numbers":"R2030",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-tissue-insect-kit",
		"RNA Extraction Numbers":"R2030",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-tissue-insect-kit",
		"RNA Extraction Numbers":"R2030",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Protein Coding Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-tissue-insect-kit",
		"RNA Extraction Numbers":"R2030",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Insect?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-tissue-insect-kit",
		"RNA Extraction Numbers":"R2030",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Oligo-dT primer-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-tissue-insect-kit",
		"RNA Extraction Numbers":"R2030",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Plant?Whole Transcriptome Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-plant-kit",
		"RNA Extraction Numbers":"R2024",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Alternative Splicing?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-plant-kit",
		"RNA Extraction Numbers":"R2024",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Non-Coding Transcript Detection?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-plant-kit",
		"RNA Extraction Numbers":"R2024",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Protein Coding Analysis?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-plant-kit",
		"RNA Extraction Numbers":"R2024",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Plant?rRNA depletion-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-plant-kit",
		"RNA Extraction Numbers":"R2024",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Oligo-dT primer-based?No TRIzol": {
		"Sample Collection Handle":"dna-rna-shield-lysis-and-collection-tubes,dna-rna-shield",
		"Sample Collection Numbers":"R1105,R1100-50,R1100-250",
		"RNA Extraction Handle":"quick-rna-plant-kit",
		"RNA Extraction Numbers":"R2024",
		"RNA Extraction 2 Handle":"dnase-i-set",
		"RNA Extraction 2 Numbers":"E1010",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Mammalian Cells?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Protein Coding Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Mammalian Cells?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Mammalian Cells?Oligo-dT primer-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Animal Tissue?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Animal Tissue?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"AnimalTissue?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Animal Tissue?Protein Coding Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Animal Tissue?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Animal Tissue?Oligo-dT primer-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"FFPE Tissue?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"deparaffinization-solution",
		"RNA Extraction 2 Numbers":"D3067-1-20",
		"RNA Extraction 3 Handle":"2x-digestion-buffer",
		"RNA Extraction 3 Numbers":"D3050-1-20",
		"RNA Extraction 4 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 4 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"FFPE Tissue?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"deparaffinization-solution",
		"RNA Extraction 2 Numbers":"D3067-1-20",
		"RNA Extraction 3 Handle":"2x-digestion-buffer",
		"RNA Extraction 3 Numbers":"D3050-1-20",
		"RNA Extraction 4 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 4 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"FFPE Tissue?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"deparaffinization-solution",
		"RNA Extraction 2 Numbers":"D3067-1-20",
		"RNA Extraction 3 Handle":"2x-digestion-buffer",
		"RNA Extraction 3 Numbers":"D3050-1-20",
		"RNA Extraction 4 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 4 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "FFPE Tissue?Protein Coding Analysis?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
	// 	"RNA Extraction 2 Handle":"deparaffinization-solution",
	// 	"RNA Extraction 2 Numbers":"D3067-1-20",
	// 	"RNA Extraction 3 Handle":"2x-digestion-buffer",
	// 	"RNA Extraction 3 Numbers":"D3050-1-20",
	// 	"RNA Extraction 4 Handle":"proteinase-k-w-storage-buffer-set",
	// 	"RNA Extraction 4 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		
	// },
	"FFPE Tissue?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"deparaffinization-solution",
		"RNA Extraction 2 Numbers":"D3067-1-20",
		"RNA Extraction 3 Handle":"2x-digestion-buffer",
		"RNA Extraction 3 Numbers":"D3050-1-20",
		"RNA Extraction 4 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 4 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "FFPE Tissue?Oligo-dT primer-based?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
	// 	"RNA Extraction 2 Handle":"deparaffinization-solution",
	// 	"RNA Extraction 2 Numbers":"D3067-1-20",
	// 	"RNA Extraction 3 Handle":"2x-digestion-buffer",
	// 	"RNA Extraction 3 Numbers":"D3050-1-20",
	// 	"RNA Extraction 4 Handle":"proteinase-k-w-storage-buffer-set",
	// 	"RNA Extraction 4 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		
	// },
	"Blood?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Protein Coding Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Blood?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Blood?Oligo-dT primer-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Buffy Coat?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Protein Coding Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Buffy Coat?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buffy Coat?Oligo-dT primer-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Serum & Plasma?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Serum & Plasma?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Serum & Plasma?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Serum & Plasma?Protein Coding Analysis?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
	// 	"RNA Extraction 2 Handle":"dna-rna-shield",
	// 	"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
	// 	"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
	// 	"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		
	// },
	"Serum & Plasma?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Serum & Plasma?Oligo-dT primer-based?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
	// 	"RNA Extraction 2 Handle":"dna-rna-shield",
	// 	"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
	// 	"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
	// 	"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		
	// },
	"Buccal, Nasal, Throat?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buccal, Nasal, Throat?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Buccal, Nasal, Throat?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Buccal, Nasal, Throat?Protein Coding Analysis?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		
	// },
	"Buccal, Nasal, Throat?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Buccal, Nasal, Throat?Oligo-dT primer-based?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		
	// },
	"Swab?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Swab?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Swab?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Swab?Protein Coding Analysis?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		
	// },
	"Swab?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Swab?Oligo-dT primer-based?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		
	// },
	"Saliva?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Saliva?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Saliva?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Saliva?Protein Coding Analysis?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
	// 	"RNA Extraction 2 Handle":"dna-rna-shield",
	// 	"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
	// 	"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
	// 	"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		
	// },
	"Saliva?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"dna-rna-shield",
		"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
		"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
		"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Saliva?Oligo-dT primer-based?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
	// 	"RNA Extraction 2 Handle":"dna-rna-shield",
	// 	"RNA Extraction 2 Numbers":"R1200-25,R1200-125",
	// 	"RNA Extraction 3 Handle":"proteinase-k-w-storage-buffer-set",
	// 	"RNA Extraction 3 Numbers":"D3001-2-5,D3001-2-20,D3001-2-60,D3001-2-125",
		
	// },
	"Urine?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Urine?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Urine?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Urine?Protein Coding Analysis?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		
	// },
	"Urine?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	// "Urine?Oligo-dT primer-based?With TRIzol": {
	// 	"Sample Collection Handle":"tri-reagent",
	// 	"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
	// 	"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
	// 	"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		
	// },
	"Fungus?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"RNA Extraction 2 Numbers":"S6012-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"RNA Extraction 2 Numbers":"S6012-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"RNA Extraction 2 Numbers":"S6012-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Protein Coding Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"RNA Extraction 2 Numbers":"S6012-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Fungus?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"RNA Extraction 2 Numbers":"S6012-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Fungus?Oligo-dT primer-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashingbead-lysis-tubes-0-1-0-5-mm",
		"RNA Extraction 2 Numbers":"S6012-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Insect?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Protein Coding Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Insect?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Insect?Oligo-dT primer-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Plant?Whole Transcriptome Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Extraction 3 Handle":"onestep-pcr-inhibitor-removal-kit,onestep-pcr-inhibitor-removal-new-kit",
		"RNA Extraction 3 Numbers":"D6030,D6035",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Alternative Splicing?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Extraction 3 Handle":"onestep-pcr-inhibitor-removal-kit,onestep-pcr-inhibitor-removal-new-kit",
		"RNA Extraction 3 Numbers":"D6030,D6035",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Non-Coding Transcript Detection?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Extraction 3 Handle":"onestep-pcr-inhibitor-removal-kit,onestep-pcr-inhibitor-removal-new-kit",
		"RNA Extraction 3 Numbers":"D6030,D6035",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Protein Coding Analysis?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Extraction 3 Handle":"onestep-pcr-inhibitor-removal-kit,onestep-pcr-inhibitor-removal-new-kit",
		"RNA Extraction 3 Numbers":"D6030,D6035",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
	"Plant?rRNA depletion-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Extraction 3 Handle":"onestep-pcr-inhibitor-removal-kit,onestep-pcr-inhibitor-removal-new-kit",
		"RNA Extraction 3 Numbers":"D6030,D6035",
		"RNA Library Kit Handle":"zymo-seq-ribofree-total-rna-library-kit",
		"RNA Library Kit Numbers":"R3000,R3003",
	},
	"Plant?Oligo-dT primer-based?With TRIzol": {
		"Sample Collection Handle":"tri-reagent",
		"Sample Collection Numbers":"R2050-1-50,R2050-1-200",
		"RNA Extraction Handle":"direct-zol-rna-microprep-kits,direct-zol-rna-miniprep-kits,direct-zol-rna-miniprep-plus-kits,direct-zol-96-rna-kits,direct-zol-96-magbead-rna",
		"RNA Extraction Numbers":"R2060,R2061,R2062,R2063,R2050,R2051,R2052,R2053,R2070,R2071,R2072,R2073,R2054,R2055,R2056,R2057,R2100,R2101,R2102,R2103",
		"RNA Extraction 2 Handle":"zr-bashing-bead-lysis-tubes",
		"RNA Extraction 2 Numbers":"S6003-50",
		"RNA Extraction 3 Handle":"onestep-pcr-inhibitor-removal-kit,onestep-pcr-inhibitor-removal-new-kit",
		"RNA Extraction 3 Numbers":"D6030,D6035",
		"RNA Library Kit Handle":"zymo-seq-switchfree-3-mrna-library-kit",
		"RNA Library Kit Numbers":"R3008,R3009",
	},
}

$(document).ready(function() {
	document.getElementById('auto-dropdown-container').style.justifyContent = 'center'
});